import React from 'react';
import LogoutButton from './LogoutButton';
import NavigationLinks from './NavigationLinks';
import SubscriptionBox from './SubscriptionBox';

interface AccountDropdownProps {}

const AccountDropdown: React.FC<AccountDropdownProps> = () => {
  return (
    <>
      {/* We have to display the SubscriptionBox only in CZ */}
      {window.country.toLowerCase() === 'cz' && <SubscriptionBox />}
      <NavigationLinks />
      <LogoutButton />
    </>
  );
};

export default AccountDropdown;
